import { useTranslation } from '@thoughtspot/i18n';
import { Button } from '@thoughtspot/radiant-react/widgets/button';
import { Card, CardBody, CardHeader, } from '@thoughtspot/radiant-react/widgets/card';
import { Horizontal } from '@thoughtspot/radiant-react/widgets/layout';
import { Toggle } from '@thoughtspot/radiant-react/widgets/toggle';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import React, { useState } from 'react';
import { FeatureManagementTranslationKeys } from './constants';
import { DisableFeatureModal } from './feature-management/disable-feature-modal';
import styles from './feature-management/feature-management.module.scss';
import { OrgsList } from './orgs-list';
const isFeatureEnabled = (feature) => feature.enabled !== undefined
    ? feature.enabled
    : feature.orgs && feature.orgs.length > 0;
export const EarlyAccessCard = ({ feature, onManageOrgs, onDisableFeature, }) => {
    const { t } = useTranslation();
    const enabled = isFeatureEnabled(feature);
    const [isDisableModalOpen, setIsDisableModalOpen] = useState(false);
    const handleToggleChange = () => {
        if (enabled) {
            setIsDisableModalOpen(true);
        }
        else {
            onManageOrgs(feature.id);
        }
    };
    const handleConfirmDisable = () => {
        setIsDisableModalOpen(false);
        onDisableFeature(feature.id);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Card, { key: feature.id, className: styles.earlyAccessCard, "data-testid": `feature-card-${feature.id}`, noBorder: true },
            React.createElement(CardHeader, { showDivider: enabled, className: styles.earlyAccessHeader },
                React.createElement(Typography, { variant: "p", noMargin: true, className: styles.earlyAccessFeatureName }, feature.name),
                React.createElement("div", { className: styles.toggleWrapper, onClick: e => e.stopPropagation(), role: "presentation" },
                    React.createElement(Toggle, { label: "", hideLabel: true, checked: enabled, name: `toggle-${feature.id}`, onChange: handleToggleChange }))),
            enabled && (React.createElement(CardBody, null,
                React.createElement(Horizontal, { className: styles.earlyAccessOrgsRow, vAlignContent: "center" },
                    React.createElement(Horizontal, { className: styles.earlyAccessOrgsText, vAlignContent: "center", spacing: "b" }, feature.orgs && feature.orgs.length > 0 ? (React.createElement(OrgsList, { orgs: feature.orgs })) : (React.createElement(Typography, { variant: "p", noMargin: true, className: styles.noOrgSelectedText }, t(FeatureManagementTranslationKeys.NO_ORG_SELECTED)))),
                    React.createElement(Button, { type: "tertiary", size: "m", text: t(feature.orgs && feature.orgs.length > 0
                            ? FeatureManagementTranslationKeys.EDIT_ORGS
                            : FeatureManagementTranslationKeys.ALLOCATE_ORGS), onClick: () => onManageOrgs(feature.id), "data-testid": `manage-orgs-${feature.id}` }))))),
        React.createElement(DisableFeatureModal, { isOpen: isDisableModalOpen, featureName: feature.name, onDismiss: () => setIsDisableModalOpen(false), onConfirm: handleConfirmDisable })));
};
//# sourceMappingURL=early-access-card.js.map